import { Grid, Dialog, DialogTitle, DialogContent, MenuItem, Button } from '@material-ui/core'
import React, { useState } from 'react'
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { getPresupuestosBuscador, getSolicitudesBuscador } from '../../../actions/autorizaciones/Autorizaciones';
import { useDispatch } from 'react-redux';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import Buscador from '../../../actions/ui/Buscador';
import { ListaSolicitudes } from './ListaSolicitudes';
import { ListaPresupuestos } from './ListaPresupuestos';
import { startAlerta } from '../../../actions/ui/alertas';
import { useTraslados } from '../../../hooks/useCases/useTraslados';

const today = new Date();
const oneYearAgo = new Date(today);
oneYearAgo.setFullYear(today.getFullYear() - 1);

export const SeguimientoSolicitudesHome = (props) => {
    const dispatch = useDispatch();
    const tipoBusqueda = "Todos";
    const altaBaja = "Todos";
    const [open, setOpen] = useState(true);
    const [fechaInicio, setFechaInicio] = useState(oneYearAgo);
    const [tipoSolicitud, setTipoSolicitud] = useState(1);
    const [fechaFin, setFechaFin] = useState(today);
    const [value, setValue] = useState(null);
    const [idSolicitud, setIdSolicitud] = useState('');
    const [idPresupuesto, setIdPresupuesto] = useState('');
    const { get } = useTraslados();

    const [openListaSolicitudes, setOpenListaSolicitudes] = useState(false);
    const [openListaPresupuestos, setOpenListaPresupuestos] = useState(false);
    const tiposSolicitudes = [
        { idTipo: 1, descripcion: 'Autorización' },
        { idTipo: 2, descripcion: 'Presupuesto' }
    ];

    const onSubmitHandler = () => {

        if (idSolicitud > 1 || value?.id_afiliado > 1 || idPresupuesto > 1) {
            if (tipoSolicitud === 1) {
                dispatch(getSolicitudesBuscador(
                    value?.id_afiliado,
                    idSolicitud,
                    fechaInicio,
                    fechaFin,
                ))
                get.solicitudes({
                    idAfiliado: value?.id_afiliado || "",
                    esSeguimientoSolicitud: true,
                    idSolicitud: idSolicitud || ""
                })
                get.dim.estados();
                get.dim.tipoTracking();

                setOpenListaSolicitudes(true)
                setOpen(false);
            }
            else if (tipoSolicitud === 2) {
                dispatch(getPresupuestosBuscador(
                    value?.id_afiliado,
                    idPresupuesto,
                    fechaInicio,
                    fechaFin,
                ))
                setOpenListaPresupuestos(true)
                setOpen(false);
            }
        }
        else {
            dispatch(startAlerta("Debe ingresar Nro Afiliado o IdSolicitud para la busqueda.", "error"))
        }


    };

    const onClose = () => {
        setOpen(false);
    };


    return (
        <React.Fragment>
            {openListaSolicitudes && (tipoSolicitud === 1) && (
                <ListaSolicitudes
                    open={openListaSolicitudes}
                    close={() => {
                        setOpenListaSolicitudes(false);
                    }}
                />
            )}
            {openListaPresupuestos && (tipoSolicitud === 2) && (
                <ListaPresupuestos
                    open={openListaPresupuestos}
                    close={() => {
                        setOpenListaPresupuestos(false);
                    }}
                />
            )}
            <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
                <DialogTitle>Seleccione</DialogTitle>
                <DialogContent>
                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12} lg={12} style={{ alignSelf: 'center', paddingLeft: 16 }} >
                                {Array.isArray(tiposSolicitudes) && tiposSolicitudes.length > 0 && (
                                    <SelectValidator
                                        fullWidth
                                        label="Seleccionar tipo de solicitud"
                                        name="tipoSolicitud"
                                        value={tipoSolicitud}
                                        onChange={(e) => setTipoSolicitud(e.target.value)}
                                        validators={['required']}
                                        errorMessages={['Este campo es requerido']}
                                    >
                                        {tiposSolicitudes.map((tipoSolicitud) => (
                                            <MenuItem
                                                key={tipoSolicitud.idTipo}
                                                value={tipoSolicitud.idTipo}
                                            >
                                                {tipoSolicitud.descripcion}
                                            </MenuItem>
                                        ))}
                                    </SelectValidator>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} style={{ alignSelf: 'center', paddingLeft: 16 }} >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Desde"
                                        disabled={idSolicitud > 1 ? true : false}
                                        format="dd/MM/yyyy"
                                        // required={true}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaInicio(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} sm={4} md={4} lg={4} style={{ alignSelf: 'center', paddingLeft: 16 }} >
                                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        label="Fecha Hasta"
                                        format="dd/MM/yyyy"
                                        disabled={idSolicitud > 1 ? true : false}
                                        clearLabel="Limpiar"
                                        cancelLabel="Cancelar"
                                        value={
                                            moment(fechaFin).isValid() ? moment(fechaFin).format() : null
                                        }
                                        onChange={(date) => {
                                            setFechaFin(date);
                                        }}
                                        KeyboardButtonProps={{
                                            "aria-label": "change date",
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            {
                                (tipoSolicitud === 1) && (
                                    <Grid item xs={12} sm={4} md={4} lg={4} style={{ alignSelf: 'center', paddingLeft: 16 }} >
                                        <TextValidator
                                            margin="normal"
                                            value={idSolicitud}
                                            inputProps={{ style: { textTransform: "uppercase" } }}
                                            label="Nro Orden"
                                            name="idSolicitud"
                                            disabled={false}
                                            onChange={(e) => setIdSolicitud(e.target.value)}
                                            autoComplete="off"
                                            fullWidth
                                        />
                                    </Grid>
                                )}
                            {
                                (tipoSolicitud === 2) && (
                                    <Grid item xs={12} sm={4} md={4} lg={4} style={{ alignSelf: 'center', paddingLeft: 16 }} >
                                        <TextValidator
                                            margin="normal"
                                            value={idPresupuesto}
                                            inputProps={{ style: { textTransform: "uppercase" } }}
                                            label="Id Presupuesto"
                                            name="idPresupuesto"
                                            disabled={false}
                                            onChange={(e) => setIdPresupuesto(e.target.value)}
                                            autoComplete="off"
                                            fullWidth
                                        />
                                    </Grid>
                                )}
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >
                                <Buscador
                                    value={value}
                                    variant="outlined"
                                    setValue={(val) => { setValue(val) }}
                                    label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                    noOptionText={"No se encuentra beneficiaria/o"}
                                    endpoint={(texto) =>
                                        `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                                    }
                                    getOptionLabel={(option) =>
                                        `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                    }
                                    renderOption={(option) => (
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <span
                                                style={
                                                    option.fecha_baja === null
                                                        ? { color: "green" }
                                                        : { color: "red" }
                                                }
                                            >
                                                {`${option.apellido_y_nombre}`}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                }}
                                            >
                                                {" "}
                                                {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                                            </span>
                                        </div>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                margin: '1rem 0',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                //disabled={props.disabled}
                                color="primary"
                            >
                                Buscar
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
